
import React from 'react';
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from 'lucide-react';

interface SuccessMessageProps {
  onSendAnother: () => void;
}

export const SuccessMessage = ({ onSendAnother }: SuccessMessageProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-4 animate-fade-in">
      <CheckCircle2 className="h-16 w-16 text-green-500" />
      <h3 className="text-xl font-medium text-sage-800">Message Received!</h3>
      <p className="text-gray-600 max-w-md">
        Thanks for reaching out! Your message has been received. I'll get back to you within 1–2 business days.
        In the meantime, feel free to connect with me on LinkedIn or explore my resume further.
      </p>
      <Button
        onClick={onSendAnother}
        className="mt-4 bg-sage-600 hover:bg-sage-700 text-white"
      >
        Send Another Message
      </Button>
    </div>
  );
};
